import HeroCollectibles from 'shared/lib/assets/img/landing/hero-collectibles.png';
import LogoMarkel from 'shared/lib/assets/img/logo/logo-markel.svg';

export const collectiblesConfig = {
  heroImages: {
    actionFigure: '/images/collectibles/hero-action-figure.svg',
    antiqueFirearm: '/images/collectibles/hero-antique-firearm.svg',
    antiqueRug: '/images/collectibles/hero-antique-rug.svg',
    automobileMemorabilia:
      '/images/collectibles/hero-automobile-memorabilia.svg',
    book: '/images/collectibles/hero-book.svg',
    chinaTableware: '/images/collectibles/hero-china-tableware.png',
    coin: '/images/collectibles/hero-coin.svg',
    comicBook: '/images/collectibles/hero-comic-book.png',
    crystal: '/images/collectibles/hero-crystal.svg',
    doll: '/images/collectibles/hero-doll.svg',
    figurine: '/images/collectibles/hero-figurine.svg',
    fineArt: '/images/collectibles/hero-fine-art.svg',
    firearm: '/images/collectibles/hero-firearm.svg',
    fishingTackle: '/images/collectibles/hero-fishing-tackle.svg',
    funko: '/images/collectibles/hero-funko.svg',
    fur: '/images/collectibles/hero-fur.png',
    glass: '/images/collectibles/hero-glass.svg',
    militaria: '/images/collectibles/hero-militaria.png',
    modelCar: '/images/collectibles/hero-model-car.svg',
    modelTrain: '/images/collectibles/hero-model-train.svg',
    movieMemorabilia: '/images/collectibles/hero-movie-memorabilia.svg',
    musicMemorabilia: '/images/collectibles/hero-music-memorabilia.svg',
    musicalInstrument: '/images/collectibles/hero-musical-instrument.svg',
    ornament: '/images/collectibles/hero-ornament.svg',
    other: '/images/collectibles/hero-other.svg',
    pottery: '/images/collectibles/hero-pottery.svg',
    rock: '/images/collectibles/hero-rock.svg',
    silverGoldPewterWare:
      '/images/collectibles/hero-silver-gold-pewter-ware.svg',
    sportsMemorabilia: '/images/collectibles/hero-sports-memorabilia.svg',
    stamp: '/images/collectibles/hero-stamp.svg',
    teddyBear: '/images/collectibles/hero-teddy-bear.svg',
    toy: '/images/collectibles/hero-toy.svg',
    tradingCard: '/images/collectibles/hero-trading-card.svg',
    vintageCamera: '/images/collectibles/hero-vintage-camera.svg',
    wine: '/images/collectibles/hero-wine.svg',
  },
  hero: {
    heading: 'Collect & Protect',
    subheading:
      'You’ve invested time, money and love into building your collection—now protect your property with comprehensive coverage.',
    cta: 'Get collectibles insurance',
    ctaLink: '/collectibles/other-insurance/start',
    img: HeroCollectibles,
  },
  underwriter: {
    img: LogoMarkel,
    name: 'Markel',
  },
  coverageDetails: [
    {
      heading: 'Theft',
      subheading:
        'Insurance safeguards your prized possessions in the event that a savvy thief makes off with part of your collection—even outside the home.',
    },
    {
      heading: 'Coverage Beyond the Basics',
      subheading:
        'Homeowners insurance will only go so far to cover the collection you took years to curate. A specialized collectibles policy guarantees coverage at the right rates.',
    },
    {
      heading: 'Damages',
      subheading:
        'Damage happens—and insurance ensures that you don’t have to worry about repair or replacement costs when it does.',
    },
    {
      heading: 'Insurance En Route',
      subheading:
        "This policy covers you from the moment of purchase, whether you're shipping an item to your home or transporting it yourself.",
    },
  ],
  scenarioDetails: {
    heading: 'Why Would You Need Collector’s Insurance?',
    scenarios: [
      {
        heading: 'Scenario 1',
        subheading:
          'A dinner party turns tragic when red wine lands on your Moroccan rug.',
      },
      {
        heading: 'Scenario 2',
        subheading:
          'Bonding with your daughter over your comic book collection is great—and a few ripped pages reveal her enthusiasm.',
      },
      {
        heading: 'Scenario 3',
        subheading:
          'You snag a sought-after piece at a trade show, but this rare coin is gone when you’re pickpocketed on the way home.',
      },
      {
        heading: 'Scenario 4',
        subheading:
          'You’re derailed when a basement flood destroys your classic vintage train set.',
      },
    ],
  },
  comparison: [
    'Instant quote',
    'Buy and manage your policy in one place',
    'Insurance explained in simple, easy-to-digest way',
    'Mobile',
    'Endorsements',
    'Plan tailored to fit your needs',
  ],
};
